<template>
  <div class="listDetailsWrapper">
    <slot name="content"></slot>
  </div>
</template>

<style scoped>
  @import '../../index.less';
</style>

